module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-Thin.75ada73.woff2";